module.exports = __webpack_public_path__ + "static/media/productos_home_botanas.4c4ea047.jpg";